import React from "react"
import { TM } from "../components/common/typography/trademark"

export const EDUCATIONAL_PAPERS = [
  {
    title: "Rethinking Cybersecurity in a Quantum World",
    snippet:
      "Rapid technological progress in recent years has created a new business reality: the digital economy. Companies today interact with each other, their partners, customers and even regulators via digital channels. Hence it is essential to ensure that sensitive data and information are secure, making encryption technology an even more critical component of today's information security infrastructure. The accelerated arrival of Quantum Computers is accompanied with the issue of Quantum threat that business leaders need to address at the earliest opportunity. Come rethink Cybersecurity with thought leaders from PwC China and 01 Communique.",
    url:
      "https://www.01com.com/pdf/2021/Rethinking-cybersecurity-in-a-quantum-world.pdf",
    image: "pwc-whitepaper.jpeg",
  },
]
export const WHITE_PAPERS = [
  {
    title: "Email Phishing: Culprit behind Ransomware",
    snippet:
      'All ransomware starts with a simple trick: To plant a malware into the target system. Email phishing is the cheapest and most common way of planting malware. Unlike other cybercrimes, email phishing makes use of social engineering techniques to prey on human emotions and behavior: greed, curiosity, fear, negligence, etc. The usual tactic is posing as legitimate businesses or authoritative bodies to pry personal information or login credentials. Phishers often try to intimidate their targets, invoking a sense of insecurity! They pretend to be your "bank" or technology service provider luring you to click on a malicious link. Once the ransomware is planted into your device, you are at their mercy.',
    url:
      "https://www.01com.com/pdf/2022/Email-Phishing-Culprit-behind-Ransomware.pdf",
    image: "phishing.png",
  },
  {
    title: "Marketing White Paper",
    snippet:
      "The more we rely on technology, the more imperative it is to protect ourselves from cyber-attacks. The impact of quantum computing on internet security is going to be massive. Its exponentially higher processing power will render current encryption systems such as RSA, obsolete and your data will be compromised. We must start planning now!",
    url: "https://01com.com/pdf/IronCAP-Marketing-White-Paper.pdf",
    image: "marketing-wp.jpeg",
  },
  {
    title: "Technical White Paper",
    snippet: (
      <>
        IronCAP
        <TM />, a patent-protected invention (US Patent Application Nos.
        16/268,098) is a unique cyber security solution: on one hand it builds
        on the current encryption technology to allow broad usage in today's
        conventional environment; on the other hand, its revolutionary
        cryptographic capability is safe against the computational power of
        quantum computers.
      </>
    ),
    url: "https://www.01com.com/pdf/ironcap-white-paper.pdf",
    image: "technical-wp.jpeg",
  },
]

export const USE_CASES = [
  {
    title: "Use Case - DAEM (World's First Quantum-Safe Bitcoin ATM)",
    snippet: (
      <>
        Cryptocurrency is redefining the conventional finance industry, and
        blockchain technology is changing the face of how businesses and
        governments operate. In December 2020, our partner, ixFintech launched
        the world's first quantum-safe DAEM (Digital Asset Exchange Machine) at
        Cyberport, Hong Kong by utilizing IronCAP
        <TM />
        's quantum-safe cryptographic technology.
      </>
    ),
    url: "https://01com.com/pdf/2021/UseCase-DAEM.pdf",
    image: "daem.jpeg",
  },
]
